// extracted by mini-css-extract-plugin
export var container = "_2l-1";
export var editor = "_2l-2";
export var resizable = "_2l-3";
export var wrapper = "_2l-0";